"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const react_1 = __importStar(require("react"));
const bind_1 = __importDefault(require("classnames/bind"));
const card_module_scss_1 = __importDefault(require("./card.module.scss"));
const cratio_png_1 = __importDefault(require("./static/cratio.png"));
const contactless_png_1 = __importDefault(require("./static/contactless.png"));
const lratio_png_1 = __importDefault(require("./static/lratio.png"));
const qr_png_1 = __importDefault(require("./static/qr.png"));
const ui_text_1 = require("@fidize/ui.text");
const _1_png_1 = __importDefault(require("./static/templates/1.png"));
const _2_png_1 = __importDefault(require("./static/templates/2.png"));
const _3_png_1 = __importDefault(require("./static/templates/3.png"));
const _4_png_1 = __importDefault(require("./static/templates/4.png"));
const _5_png_1 = __importDefault(require("./static/templates/5.png"));
const _6_png_1 = __importDefault(require("./static/templates/6.png"));
const _7_png_1 = __importDefault(require("./static/templates/7.png"));
const _8_png_1 = __importDefault(require("./static/templates/8.png"));
const color1_png_1 = __importDefault(require("./static/templates/color1.png"));
const _10_png_1 = __importDefault(require("./static/templates/10.png"));
const color2_png_1 = __importDefault(require("./static/templates/color2.png"));
const color3_png_1 = __importDefault(require("./static/templates/color3.png"));
const color4_png_1 = __importDefault(require("./static/templates/color4.png"));
const _11_png_1 = __importDefault(require("./static/templates/11.png"));
const _12_png_1 = __importDefault(require("./static/templates/12.png"));
class Card extends react_1.Component {
    constructor(props) {
        super(props);
        this.state = {
            cardFaceColor: "cardFaceGreen",
            cardPaintColor: "cardPaintBlack",
            color: false,
            logoSize: "Full",
            template: "",
            basic: false,
            frontFaceDelay: true,
            backFaceDelay: false,
            matt: true,
            signature: "Mario Bianchi",
            flipped: false,
            contactless: true,
            code: false
        };
        this.templates = [
            "",
            _1_png_1.default,
            _2_png_1.default,
            _3_png_1.default,
            _4_png_1.default,
            _5_png_1.default,
            _6_png_1.default,
            _7_png_1.default,
            _8_png_1.default,
            color1_png_1.default,
            _10_png_1.default,
            color2_png_1.default,
            color3_png_1.default,
            color4_png_1.default,
            _11_png_1.default,
            _12_png_1.default
        ];
        this.capitalize = (s) => {
            if (typeof s !== 'string')
                return '';
            return s.charAt(0).toUpperCase() + s.slice(1);
        };
        this.flip = () => {
            this.setState({
                flipped: !this.state.flipped,
                frontFaceDelay: !this.state.frontFaceDelay,
                backFaceDelay: !this.state.backFaceDelay
            });
        };
        this.init(props);
    }
    shouldComponentUpdate(props) {
        this.init(props);
        return true;
    }
    init(props) {
        this.state.cardFaceColor = props.hasOwnProperty("faceColor") ? "cardFace" + this.capitalize(props['faceColor']) : "cardFaceGreen";
        if (props.hasOwnProperty("paintColor")) {
            // Colore scritte black se stampa a colori
            if (props['paintColor'] == "color") {
                this.state.cardPaintColor = "cardPaintBlack";
                this.state.color = true;
            }
            else {
                this.state.cardPaintColor = "cardPaint" + this.capitalize(props['paintColor']);
                if (props['paintColor'] == "colored") {
                    this.state.cardPaintColor = "cardPaintBlack";
                }
                this.state.color = false;
            }
        }
        this.state.logoSize = props.hasOwnProperty("logoSize") ? props.logoSize : "M";
        this.state.template = props.hasOwnProperty("template") ? parseInt(props.template) : "";
        this.state.matt = props.hasOwnProperty("matt") ? props.matt : true;
        this.state.flipped = props.hasOwnProperty("flipped") ? props.flipped : false;
        if (this.state.flipped) {
            this.state.frontFaceDelay = false;
            this.state.backFaceDelay = true;
        }
        else {
            this.state.frontFaceDelay = true;
            this.state.backFaceDelay = false;
        }
        this.state.contactless = props.hasOwnProperty("contactless") ? props.contactless : true;
        this.state.code = props.hasOwnProperty("code") ? props.code : false;
        this.state.signature = props.hasOwnProperty("signature") ? props.signature : false;
        this.state.basic = props.hasOwnProperty("basic") ? props.basic : false;
    }
    render() {
        var cx = bind_1.default.bind(card_module_scss_1.default);
        var logo_img = this.props.hasOwnProperty("logo") ? (this.props.logo.indexOf('.') == 0 ? require(this.props.logo + "") : this.props.logo) : "";
        if (this.props.paintColor == "colored") {
            logo_img = require("./static/templates/colored.png");
        }
        if (typeof logo_img == 'object') {
            logo_img = logo_img.default;
        }
        var contactless_img = contactless_png_1.default;
        var templateSize = card_module_scss_1.default['cardLogoFull'];
        var logoSize = card_module_scss_1.default['cardLogo' + (this.state.template == "" | this.state.template == 0 ? this.state.logoSize : "M")];
        return react_1.default.createElement("div", { className: card_module_scss_1.default["cardContainer"] },
            react_1.default.createElement("img", { src: cratio_png_1.default, className: card_module_scss_1.default["cardRatio"] }),
            react_1.default.createElement("div", { className: cx(("card " + (this.state.flipped ? "flipped" : "")).split(" ")) },
                react_1.default.createElement("div", { className: cx(((this.state.matt ? "cardFrontMatt " : "cardFront ") + this.state.cardFaceColor + (this.state.frontFaceDelay ? " cardAnimationDelay" : "")).split(" ")) },
                    this.state.template == "" && !this.state.basic ?
                        this.state.color ?
                            react_1.default.createElement("div", { className: cx(("cardLogoColor cardPaint " + (this.state.frontFaceDelay ? " cardPrintAnimationDelay" : "")).split(" ")), style: { color: '#000', backgroundImage: "url('" + logo_img + "')", maskImage: "unset", WebkitMaskImage: "unset" } },
                                react_1.default.createElement("img", { src: lratio_png_1.default, className: card_module_scss_1.default["logoRatio"] })) :
                            this.props.paintColor != "colored" ?
                                react_1.default.createElement("div", { className: cx(("cardLogo cardPaint " + this.state.cardPaintColor + (this.state.frontFaceDelay ? " cardPrintAnimationDelay" : "")).split(" ")) + " " + logoSize, style: { color: '#000', backgroundImage: "", maskImage: "url('" + logo_img + "')", WebkitMaskImage: "url('" + logo_img + "')" } },
                                    react_1.default.createElement("img", { src: lratio_png_1.default, className: card_module_scss_1.default["logoRatio"] })) :
                                react_1.default.createElement("div", { className: cx(("cardLogoColored cardPaint " + (this.state.frontFaceDelay ? " cardPrintAnimationDelay" : "")).split(" ")) + " " + logoSize, style: { color: '#000', backgroundImage: "url('" + logo_img + "')", maskImage: "unset", WebkitMaskImage: "unset" } },
                                    react_1.default.createElement("img", { src: lratio_png_1.default, className: card_module_scss_1.default["logoRatio"] }))
                        : react_1.default.createElement(react_1.default.Fragment, null),
                    this.state.template == "" ? react_1.default.createElement(react_1.default.Fragment, null) :
                        this.state.color ?
                            react_1.default.createElement("div", { className: cx(("cardLogoColor cardPaint cardTemplate " + this.state.cardPaintColor + (this.state.frontFaceDelay ? " cardPrintAnimationDelay" : "")).split(" ")) + " " + templateSize, style: { color: '#000', backgroundImage: "url('" + this.templates[this.state.template] + "')", maskImage: "unset", WebkitMaskImage: "unset" } },
                                react_1.default.createElement("img", { src: lratio_png_1.default, className: card_module_scss_1.default["logoRatio"] })) :
                            react_1.default.createElement("div", { className: cx(("cardLogo cardPaint cardTemplate " + this.state.cardPaintColor + (this.state.frontFaceDelay ? " cardPrintAnimationDelay" : "")).split(" ")) + " " + templateSize, style: { position: "absolute", color: '#000', backgroundImage: "", maskImage: "url('" + this.templates[this.state.template] + "')", WebkitMaskImage: "url('" + this.templates[this.state.template] + "')" } },
                                react_1.default.createElement("img", { src: lratio_png_1.default, className: card_module_scss_1.default["logoRatio"] })),
                    this.state.contactless & this.state.template == "" ? react_1.default.createElement("div", { className: cx(("cardContactless cardPaint " + this.state.cardPaintColor + (this.state.frontFaceDelay ? " cardPrintAnimationDelay" : "")).split(" ")), style: { color: '#000', maskImage: "url('" + contactless_img + "')", WebkitMaskImage: "url('" + contactless_img + "')" } }) : react_1.default.createElement(react_1.default.Fragment, null),
                    this.state.basic ?
                        react_1.default.createElement(ui_text_1.Text, { type: "basic" },
                            react_1.default.createElement("span", { className: cx(("cardPaint " + this.state.cardPaintColor + (this.state.frontFaceDelay ? " cardPrintAnimationDelay" : "") + " cardBasicSignature").split(" ")) }, this.state.signature))
                        : react_1.default.createElement(react_1.default.Fragment, null)),
                react_1.default.createElement("div", { className: cx(((this.state.matt ? "cardBackMatt " : "cardBack ") + this.state.cardFaceColor + (this.state.backFaceDelay ? " cardAnimationDelay" : "")).split(" ")) },
                    react_1.default.createElement("span", { className: cx(("cardPaint signature " + this.state.cardPaintColor + (this.state.backFaceDelay ? " cardPrintAnimationDelay" : "")).split(" ")) }, this.state.signature),
                    react_1.default.createElement("div", { className: cx(("cardQr cardPaint " + this.state.cardPaintColor + (this.state.backFaceDelay ? " cardPrintAnimationDelay" : "")).split(" ")), style: { color: '#000', maskImage: "url('" + qr_png_1.default + "')", WebkitMaskImage: "url('" + qr_png_1.default + "')" } }),
                    !this.state.code ? react_1.default.createElement(react_1.default.Fragment, null) : react_1.default.createElement(ui_text_1.Text, { type: "code" },
                        react_1.default.createElement("span", { className: cx(("cardCode cardPaint " + (this.state.backFaceDelay ? " cardPrintAnimationDelay" : "") + " " + this.state.cardPaintColor).split(" ")) }, "CODE: 000000")))));
    }
}
exports.Card = Card;
//# sourceMappingURL=card.js.map